import api from '../../lib/api';
import type { ActionsInboxItem, FetchActionsInboxParams } from './types';

export const fetchActionsInbox = async (
  params: FetchActionsInboxParams = {},
): Promise<ActionsInboxItem[]> => {
  const query: Record<string, string | number> = {};
  if (params.assignedTo !== undefined) query.assignedTo = params.assignedTo;
  if (params.status) query.status = params.status;
  if (params.origin) query.origin = params.origin;
  if (params.overdue === true) query.overdue = 'true';
  if (params.overdue === false) query.overdue = 'false';

  const { data } = await api.get<{ data: ActionsInboxItem[] }>('actions-inbox', { params: query });
  return data.data;
};
